import vars from '../style/base/vars.less';
export default vars;
